import React from 'react';
import WarningBox from '../../../../../components/Modules/WarninigBox';
import './hints.less';


const Hints = () => (
  <div className="ir-reports-tab-hints">
    <h4>How to run custom reports</h4>
    <ol>
      <li>Enter required case information.</li>
      <li>Enter optional filters if desired.</li>
      <li>Click Run Report to get results.</li>
    </ol>

    <h4>Afterwards you can</h4>
    <ol>
      <li>Download a CSV of the results, and</li>
      <li>Setup delivery schedule to run this report and get an email going forward</li>
    </ol>

    <WarningBox>
        Warning: you will be billed for the total number of pages (this report is not subject to the 30-page limit).
    </WarningBox>
  </div>
);

export default Hints;



// WEBPACK FOOTER //
// ./src/pages/filings/SearchCourtRecords/ReportsTab/Hints/Hints.js